import { render, staticRenderFns } from "./oc-tag.vue?vue&type=template&id=b7505228"
import script from "./oc-tag.vue?vue&type=script&lang=js"
export * from "./oc-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../marketplace/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports